import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as NotificationIcon } from "../assets/icons/notificationIcon.svg";
import UserImage from "../assets/images/no-profile.jpg";
import Logo from "../assets/images/logo.svg";
import { connect, useDispatch, useSelector } from "react-redux";

import { covertURl } from "../util/AwsFunction";
import { getDefaultCurrency } from "../store/currency/currency.action";
import { projectName } from "../util/config";

const Navbar = () => {
  const loggedUser = JSON.parse(sessionStorage.getItem("admin"));
  const { profile } = useSelector((state) => state.loggedUser);
  const { orgProfile } = useSelector((state) => state.organization);
  const [showImage, setShowImage] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      if (!loggedUser.isOrg) {
        const fileNameWithExtensionThumbnail = loggedUser?.image
          ?.split("/")
          .pop();
        const { imageURL: image } = await covertURl(
          "userImage/" + fileNameWithExtensionThumbnail,
        );
        setShowImage(image);
      }
    };
    if (loggedUser) {
      fetchData();
      const interval = setInterval(fetchData, 1000 * 60);
      return () => clearInterval(interval);
    }
  }, [loggedUser]);

  useEffect(() => {
    if (profile?.profileImage) {
      setShowImage(profile.profileImage);
    }
  }, [profile]);

  useEffect(() => {
    dispatch(getDefaultCurrency());
  }, [dispatch]);

  return (
    <>
      <div className="mainNavbar webNav me-4">
        <div className="row">
          <div className="navBox " style={{ paddingTop: "8px" }}>
            <div
              className="navBar boxBetween row-gap-2 px-4 flex-wrap"
              style={{ padding: "10px 0px" }}
            >
              <div className="d-flex align-items-center">
                <div className="navToggle" id={"toggle"}>
                  <i class="fa-solid fa-bars text-black cursor"></i>
                </div>
                <div className="logo-show-nav ms-3">
                  <div className="sideBarLogo boxCenter">
                    <Link
                      to={
                        loggedUser.isOrg
                          ? "/org/dashboard"
                          : "/admin/mainDashboard"
                      }
                      className="d-flex align-items-center"
                    >
                      <img src={Logo} alt="" width={"30px"} />
                      <span className="fs-5 fw-bold text-black">
                        {projectName}
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-7">
                <div className="navIcons d-flex align-items-center justify-content-end">
                  <div
                    className="pe-4 text-end"
                    style={{ backgroundColor: "inherit" }}
                  >
                    {orgProfile?.name ? (
                      <div className="fw-semibold fs-6">{orgProfile.name}</div>
                    ) : null}
                    <span className="fs-6 fw-semibold text-capitalize">
                      {profile?.name}
                    </span>
                    {profile?.role && (
                      <span className="fs-6 text-capitalize ms-1">
                        ({profile?.role?.replace("org_", "")})
                      </span>
                    )}
                  </div>
                  {loggedUser?.isOrg ? (
                    <div className="cursor">
                      <Link
                        to="/org/profile"
                        style={{ backgroundColor: "inherit" }}
                      >
                        <img
                          src={showImage || UserImage}
                          alt=""
                          width={`50px`}
                          height={`50px`}
                          style={{
                            borderRadius: "15px",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.src = UserImage;
                          }}
                          className="cursor"
                        />
                      </Link>
                    </div>
                  ) : loggedUser?.isSubAdmin === false ? (
                    <div className="cursor">
                      <Link
                        to="/admin/profile"
                        style={{ backgroundColor: "inherit" }}
                      >
                        {showImage && (
                          <img
                            src={showImage}
                            alt=""
                            width={`50px`}
                            height={`50px`}
                            style={{
                              borderRadius: "15px",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.src = UserImage;
                            }}
                            className="cursor"
                          />
                        )}
                      </Link>
                    </div>
                  ) : (
                    <img
                      src={UserImage}
                      alt=""
                      width={`50px`}
                      height={`50px`}
                      style={{
                        borderRadius: "15px",
                        objectFit: "cover",
                      }}
                      className="cursor"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {})(Navbar);
